import styled from 'styled-components';

export const ToastWrapper = styled.div<{ $isError?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 280px;
  max-width: min(400px, 90vw);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  border-left: 4px solid
    ${({ theme, $isError }) =>
      $isError ? theme.colors.reliability.low : theme.colors.reliability.high};
  padding: 12px 16px;
  background: ${({ theme }) => theme.colors.background.extraLight};

  & p {
    margin: 0;
  }
`;

export const ToastMessage = styled.div`
  overflow-wrap: break-word;
  flex: 1;
  min-width: 0;
  word-break: break-word;
`;

export const ToastIconWrapper = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
`;

export const ToastCloseButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  border: none;
  border-radius: 4px;
  padding: 4px;
  background: none;
  color: ${({ theme }) => theme.colors.primaryText};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.background.light};
  }
`;
